import { createKeys, featureKeys } from "Utilities/ReactQuery/fnKeys";

const GET_FUND_LIST = "getFundList";
const GET_FUND_ARCHIVE_ELIGIBILITY = "getFundArchiveEligibility";
const GET_FUNDS = "getFunds";
const GET_CAMPAIGNS = "getCampaigns";
const MAIN_SETTINGS = "mainSettings";
const MEDIA_SETTINGS = "mediaSettings";
const OTHER_SETTINGS = "otherSettings";
const HAPPE_SETTINGS = "happeSettings";
const UPLOAD_PHOTO = "uploadPhoto";
const CTA = "cta";
const REORDER_CTA = "reorderCta";

const givingKeys = createKeys(featureKeys.GIVING, {
  getFundList: () => [GET_FUND_LIST],
  getFundArchiveEligibility: (fundID) => [GET_FUND_ARCHIVE_ELIGIBILITY, fundID],
  getFunds: () => [GET_FUNDS],
  getCampaigns: () => [GET_CAMPAIGNS],
  mainSettings: () => [MAIN_SETTINGS],
  mediaSettings: () => [MEDIA_SETTINGS],
  otherSettings: () => [OTHER_SETTINGS],
  happeSettings: () => [HAPPE_SETTINGS],
  uploadPhoto: () => [UPLOAD_PHOTO],
  cta: () => [CTA],
  reorderCta: () => [REORDER_CTA],
});

export default givingKeys;
